import React from 'react';
import PropTypes from 'prop-types';
import TimelineConnector from '@mui/lab/TimelineConnector';
import { withStyles } from '@mui/styles';

const CustomTimelineConnector = withStyles({
  root: {
    backgroundColor: '#199DA3',
  },
})(TimelineConnector);

const UiTimelineConnector = (props) => {
  return <CustomTimelineConnector {...props} />;
};

UiTimelineConnector.propTypes = {
  children: PropTypes.array,
};

export default UiTimelineConnector;
